import { render, staticRenderFns } from "./PartnersManagementScreen.vue?vue&type=template&id=44bd7840&scoped=true&"
import script from "./PartnersManagementScreen.vue?vue&type=script&lang=js&"
export * from "./PartnersManagementScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd7840",
  null
  
)

export default component.exports